import { render, staticRenderFns } from "./quoteCard.vue?vue&type=template&id=6032c3c4&scoped=true&"
import script from "./quoteCard.vue?vue&type=script&lang=js&"
export * from "./quoteCard.vue?vue&type=script&lang=js&"
import style0 from "./quoteCard.vue?vue&type=style&index=0&id=6032c3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6032c3c4",
  null
  
)

export default component.exports